module.exports = __webpack_public_path__ + "static/guard_drake_green-cbeae9552b1343bc7df8ad9e6108a1a0.jpeg";